import { PickType } from '@nestjs/swagger';
import { JobPhaseBumpNoteDto } from './job-phase-bump-note.dto';
import { JobPhaseBumpNoteCreatableInterface } from '../interfaces/job-phase-bump-note-creatable.interface';

export class JobPhaseBumpNoteCreateDto
  extends PickType(JobPhaseBumpNoteDto, ['note', 'jobPhaseBumpId'])
  implements JobPhaseBumpNoteCreatableInterface {}
